//chart theme
export const CHART_THEME = 'macarons'

//projectType
export const SUB_PROJECT = 'subproject'
export const PROPOSAL = 'proposal'
